import { useCallback, useContext, useState } from 'react';
import { SnackbarContext } from '#/utils/snackbar/snackbarProvider';

/**
 * クリップボードへコピーするhooks
 */
export function useCopyToClipboard() {
  const [error, setError] = useState<Error | null>(null);
  const snackbar = useContext(SnackbarContext);
  const copy = useCallback(
    async (text: string) => {
      setError(null);
      try {
        await navigator.clipboard.writeText(text);
        snackbar.add({
          id: Date.now(),
          message: 'コピーしました',
          notificationLevel: 'success',
        });
      } catch (e: unknown) {
        if (e instanceof Error) {
          setError(e);
        }
      }
    },
    [snackbar]
  );
  return {
    copy,
    error,
  };
}
